import { useId, type InputHTMLAttributes } from 'react';

import './campo.css';

export type PropsCampo = {
  rotulo: string;
  /** Texto de apoio permanente, ligado por `aria-describedby`. */
  dica?: string;
  /** Presente, marca `aria-invalid` e anuncia o texto. */
  erro?: string;
} & InputHTMLAttributes<HTMLInputElement>;

export function Campo({
  rotulo,
  dica,
  erro,
  id,
  className,
  ...resto
}: PropsCampo) {
  // `useId` dá um identificador estável por instância: dois campos na mesma
  // tela não colidem, e o valor sobrevive à hidratação.
  const gerado = useId();
  const idCampo = id ?? `campo${gerado}`;
  const idDica = `${idCampo}-dica`;
  const idErro = `${idCampo}-erro`;
  const descritores = [dica ? idDica : null, erro ? idErro : null].filter(
    (x): x is string => x !== null,
  );
  return (
    <div className={className ? `ds-campo ${className}` : 'ds-campo'}>
      <label className="ds-campo__rotulo" htmlFor={idCampo}>
        {rotulo}
      </label>
      {dica ? (
        <p className="ds-campo__dica" id={idDica}>
          {dica}
        </p>
      ) : null}
      <input
        className="ds-campo__entrada"
        id={idCampo}
        aria-describedby={
          descritores.length > 0 ? descritores.join(' ') : undefined
        }
        // `aria-invalid="false"` é ruído: só existe quando há erro de fato.
        aria-invalid={erro ? true : undefined}
        {...resto}
      />
      {erro ? (
        <p className="ds-campo__erro" id={idErro} role="alert">
          {/* Erro nunca vai só na cor: o símbolo o distingue de um texto de
              apoio comum em monocromia. */}
          <span aria-hidden="true">⚠</span> {erro}
        </p>
      ) : null}
    </div>
  );
}
